import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Icon3dot } from '../../../assets/icon';
import ButtonTypes from '../../../constants/buttonTypes';
import ButtonDropdownMenuItem from '../../../components/ButtonDropdownMenuItem/ButtonDropdownMenuItem';
import CustomDropdownMenu from '../../../components/CustomDropdownMenu/CustomDropdownMenu';

const actionButtonClassName = 'p-0 w-[26px] h-[26px] min-w-[26px] min-h-[26px]';
const actionContainerClassName = 'min-w-[250px]';

function PrinterActions({ side, onPrint, onCancel }) {
  const [visible, toggleVisible] = useState(false);

  return (
    <CustomDropdownMenu
      Icon={Icon3dot}
      btnType={ButtonTypes.LIGHT}
      side={side}
      drop="right"
      btnStyle={actionButtonClassName}
      containerStyle={actionContainerClassName}
      visible={visible}
      toggleVisible={toggleVisible}
    >
      <ButtonDropdownMenuItem
        text="Print Task"
        onClick={onPrint}
      />
      <ButtonDropdownMenuItem
        text="Cancel Task"
        onClick={onCancel}
        danger
      />
    </CustomDropdownMenu>
  );
}

PrinterActions.propTypes = {
  side: PropTypes.string,
  onPrint: PropTypes.func,
  onCancel: PropTypes.func,
};

PrinterActions.defaultProps = {
  side: 'top',
  onPrint: () => {},
  onCancel: () => {},
};
export default PrinterActions;
